import { render, staticRenderFns } from "./index-send.vue?vue&type=template&id=31dacc7a&scoped=true"
import script from "./index-send.vue?vue&type=script&lang=js"
export * from "./index-send.vue?vue&type=script&lang=js"
import style0 from "./index-send.vue?vue&type=style&index=0&id=31dacc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dacc7a",
  null
  
)

export default component.exports